import { Observable } from 'rxjs';

import { Location, LocationQueryParams } from '../models/location.model';
import { ListResponse } from '../models/utility.model';

export abstract class LocationGateway {
  abstract listLocations(params: LocationQueryParams): Observable<ListResponse<Location>>;
}
